import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
import { camelCase } from "lodash";
export default defineComponent({
  name: "StatusDropdown",
  props: {
    partialSync: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    statusInProgressOrLoading() {
      return this.statusInProgress || this.loading || this.processing;
    },
    processing() {
      return this.status === "processing";
    },
    statusInProgress() {
      const inProgressStatus = ["ready-to-close", "accepted", "approved", "in-progress", "confirmed"];
      return !_includesInstanceProperty(inProgressStatus).call(inProgressStatus, this.status);
    },
    translatedStatus() {
      const key = `filogix.dealStatuses.${camelCase(this.status)}`;
      return this.$t(key);
    },
    buttonVariant() {
      if (this.processing) return "white";
      return this.status;
    }
  },
  methods: {
    handleStatusChange(status) {
      this.$emit("change", status);
    }
  }
});